import { UPSERT_PAYMENT } from '../../actions/payments';
import { CREATE_PROGRAM } from '../../actions/programs';
import { SUCCESS_MODAL } from '../../actions/uiLogic';
import { genericErrorMsg } from '../../pages/common/components/constants';
import {
  programCreationSuccess,
  shareUTRSuccess,
} from '../../pages/WalletPrograms/constants';

export const CLOSE_TOAST = 'CLOSE_TOAST';
export const OPEN_TOAST = 'OPEN_TOAST';

export default function uiLogic(state = {}, action = {}) {
  const {
    type = '',
    toastDetails = {},
    successMessage = {},
    newProgram = {},
  } = action;

  switch (type) {
    case CLOSE_TOAST:
      return {
        ...state,
        toastDetails: { show: false },
      };
    case OPEN_TOAST:
      return {
        ...state,
        toastDetails,
      };
    case CREATE_PROGRAM.SUCCESS: {
      const {
        title = programCreationSuccess.title,
        subtitle = programCreationSuccess.subtitle,
      } = newProgram;
      const isGifting = window.location.href?.includes('/gifting');
      return {
        ...state,
        message: {
          title,
          subtitle,
          show: !isGifting,
          type: 'success',
        },
      };
    }
    case UPSERT_PAYMENT.SUCCESS:
      return {
        ...state,
        message: {
          title: shareUTRSuccess.title,
          subtitle: shareUTRSuccess.subtitle,
          show: true,
          type: 'success',
        },
      };
    case SUCCESS_MODAL.SUCCESS:
      const { title = '', subtitle = '' } = successMessage;
      return {
        ...state,
        message: {
          title,
          subtitle,
          show: true,
        },
      };
    case SUCCESS_MODAL.CLEAR:
      return {
        ...state,
        message: { show: false },
      };
    default:
      return state;
  }
}

export const closeToast = () => ({
  type: CLOSE_TOAST,
});

export const openSuccessToast = text => ({
  type: OPEN_TOAST,
  toastDetails: { text, show: true, type: 'success' },
});

export const openWarningToast = text => ({
  type: OPEN_TOAST,
  toastDetails: { text, show: true, type: 'warning' },
});

export const openErrorToast = (text = genericErrorMsg) => ({
  type: OPEN_TOAST,
  toastDetails: { text, show: true, type: 'error' },
});

export const openDarkDefaultToast = text => ({
  type: OPEN_TOAST,
  toastDetails: { text, show: true, type: 'darkDefault' },
});
